module.exports = __webpack_public_path__ + "media/singes.16ae9578.mp4";